import {Component, OnInit} from '@angular/core';
import {HtmlUtilsService} from "../html-utils/html-utils.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../auth/auth.service";
import {first} from "rxjs/operators";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  showPassword = false;
  loading = false;
  highContrast = false;
  loginSuccess = false;
  emailVerified: boolean = undefined

  constructor(private htmlUtils: HtmlUtilsService,
              private formBuilder: FormBuilder,
              private authService: AuthService,
              private route: Router) {
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: new FormControl(
        this.rememberedEmail() || '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]
      ),
      password: new FormControl(
        this.rememberedPassword() || '',
        Validators.required
      ),
      rememberMe: new FormControl(
        this.authService.rememberedUserValue ? true : false
      )
    });
  }

  private rememberedEmail(): string {
    return (!this.authService.rememberedUserValue || this.authService.rememberedUserValue.email === null || this.authService.rememberedUserValue.email === undefined)
      ? undefined
      : this.authService.rememberedUserValue.email;
  }

  private rememberedPassword(): string {
    return (!this.authService.rememberedUserValue || this.authService.rememberedUserValue.password === null || this.authService.rememberedUserValue.password === undefined)
      ? undefined
      : this.authService.rememberedUserValue.password;
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }
    const email = this.formField.email.value.trim();
    const password = this.formField.password.value.trim();
    this.loading = true;


    this.authService
      .login(email, password)
      .pipe(first())
      .subscribe(
        () => {
          this.loginSuccess = true;
          if (this.formField.rememberMe.value) {
            this.authService.rememberUser(email, password);
          } else {
            this.authService.forgetUser();
          }
          this.route.navigateByUrl('/');
        },
        (error) => {
          this.loading = false;
          this.loginSuccess = false;
          if (error.status === 403) {
            this.emailVerified = false;
          } else {
            this.emailVerified = true;
          }
        }
      );
  }

  get formField() {
    return this.form.controls;
  }

  toggleShow() {
    this.showPassword = !this.showPassword;
  }
}
